export const BaseDict = {
    YouWonJackpot: "You won jackpot",
    BackToBetting: "Back to betting"
};
//# sourceMappingURL=dict.js.map